import { createFileRoute, Navigate } from "@tanstack/react-router";

import React from "react";
import { AccountProvider } from "src/context/account";

export const Route = createFileRoute("/")({
    /**
     * Wrapper around the index route to forward to the correct sub-path
     *
     * @returns The rendered component
     */
    component: () => (
        <AccountProvider>
            <Navigate to={"/a/dashboard"} />
        </AccountProvider>
    ),
});
